import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualOverviewPage() {
    return <MarkdownDocPage title="Overview" markdownUrl="/docs/user-manual/pages/overview.md" />;
}

